const blockWrapperStyles = {
  root: {
    borderRadius: '6px',
    padding: '12px',
  },
};

export default blockWrapperStyles;
